<panel width="700">
	<h1>{{ 'company.orders.header' | translate }}</h1>
	<list-orders [companyId]="companyId" />
</panel>
